import angular from 'angular';

export class FooterComponent {
  constructor($state, Config) {
    'ngInject';

    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.$state = $state;
    this.isFrontpage = false;
    this.year = (new Date()).getFullYear();
  }

  $doCheck() {
    this.isFrontpage = this.$state.current.name == 'main';
    this.isDigitalSignage = this.$state.current.name == 'digital-signage';

    if (this.isFrontpage)
      jQuery("body").addClass("frontpage-footer-background");
    else
      jQuery("body").removeClass("frontpage-footer-background");
  }
}

/**
 * @ngdoc directive
 * @name directives.directive:footer
 * @element footer
 * @function
 *
 * @description
 * Renders the footer of the page
 *
 * **Note:** nothing special, just the test of a note
 *
 * @example
 <example module="directives">
 <file name="index.html">
   <footer />
 </file>
 </example>
 */
export default angular.module('conduu.ap.components.footer', [])
  .component('footer', {
    template: require('./footer.html'),
    controller: FooterComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/~ap/components/footer/footer.component.js